import React from 'react';
import { Col, Row, Spinner, Button, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faHome, faUndoAlt, faAward, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import Translate, { t } from '../../common/Translate';
import MeetingTag from '../MeetingTag';
import editIcon from '../../../assets/img/edit.svg';
import { useAppointment } from '../../../hooks/useCalendar/useRecordBlocs/useAppointment';
import { EditAppointmentModal } from './EditAppointmentModal';
import { DeleteModal } from './DeleteModal';
import AutobizStrapPopup from '../../common/Modal/AutobizStrapPopup';

export const AppointmentBloc = ({ recordId }) => {
  const {
    appointment,
    fileNumber,
    pointOfSaleName,
    pointOfSaleId,
    buyerFullName,
    isRecordLoading,
    isHBS,
    formSource,
    allowDelete,
    allowVinCheck,
    createVinCheck,
    isLoadingVin,
    allowEdit,
    status,
    toggleEditModal,
    editModalIsOpen,
    toggleDeleteModal,
    deleteModalIsOpen,
    openInfoBull,
    tooltipOpen,
    recordTypeId,
    fordGuaranteeReference,
    records,
    role,
    counterInspection,
    showModelCounterInspaction,
    isNrmRecord,
    guaranteedPrice,
    isOpenGuaranteeId,
    onClickGuaranteeId,
    nrmStatusId,
    buyers,
    buyerRecordName,
    chnageBuyerName,
    updateBuyer,
    allowedChangeBuyer,
  } = useAppointment(recordId);

  const { appointmentDate, appointmentTime, clientPhone, appointmentDateTime, journeyCustomerType } = appointment;

  let tooltipInfo = {};
  if (journeyCustomerType?.toLowerCase() === 'b2e') {
    tooltipInfo.icon = faAward;
    tooltipInfo.label = 'nrmFile';
    tooltipInfo.isOpen = tooltipOpen.nrmFile;
    tooltipInfo.title = 'stellaClub';
    tooltipInfo.onClick = () => openInfoBull('nrmFile');
  } else if (formSource === 'clic2sell') {
    tooltipInfo.icon = faHome;
    tooltipInfo.label = 'hbsFile';
    tooltipInfo.isOpen = tooltipOpen.homeHBS;
    tooltipInfo.onClick = () => openInfoBull('homeHBS');
  } else if (formSource === 'clic2buy') {
    tooltipInfo.icon = faQrcode;
    tooltipInfo.label = 'clic2buyFile';
    tooltipInfo.isOpen = tooltipOpen.clic2buyFile;
    tooltipInfo.onClick = () => openInfoBull('clic2buyFile');
  } else if (isNrmRecord) {
    tooltipInfo.icon = faAward;
    tooltipInfo.label = 'nrmFile';
    tooltipInfo.isOpen = tooltipOpen.nrmFile;
    tooltipInfo.onClick = () => openInfoBull('nrmFile');
  } else if (fordGuaranteeReference) {
    tooltipInfo.icon = faAward;
    tooltipInfo.label = 'guaranteedPriceLabel';
    tooltipInfo.isOpen = tooltipOpen.ford;
    tooltipInfo.onClick = () => openInfoBull('ford');
  } else if (recordTypeId === 2) {
    tooltipInfo.icon = faUndoAlt;
    tooltipInfo.label = 'counterAppraisalFile';
    tooltipInfo.isOpen = tooltipOpen.counterApp;
    tooltipInfo.onClick = () => openInfoBull('counterApp');
  } else {
    tooltipInfo = false;
  }
  const ValueContainer = ({ ...props }) => {
    return <components.ValueContainer {...props} />;
  };
  const CustomSingleValue = ({ ...props }) => {
    return <components.SingleValue {...props} />;
  };
  return (
    <div className="calendar-meeting-info">
      <AutobizStrapPopup />
      {(isRecordLoading && <Spinner color="primary" size="sm" />) || (
        <>
          <div className="title">
            {t('file_number')} {fileNumber}{' '}
            {isHBS && (
              <>
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpen.phoneHBS}
                  target="Tooltip-phoneHBS"
                  toggle={() => !isMobile && openInfoBull('phoneHBS')}
                  className="my-tooltip"
                >
                  {t('phoneHBS')}
                </Tooltip>
                <span
                  className="badge calendar-badge calendar-badge-grey-light success customer-phone"
                  id="Tooltip-phoneHBS"
                  onClick={() => openInfoBull('phoneHBS')}
                  onKeyDown={() => {}}
                  role="presentation"
                >
                  {clientPhone}
                </span>
              </>
            )}
            <div className="cta-title-block">
              {allowEdit && role !== 'viewer' && (
                <div
                  onClick={toggleEditModal}
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}
                  data-testid="edit-appointement"
                >
                  <img src={editIcon} alt="edit" />
                </div>
              )}
              {allowDelete && !isNrmRecord && role !== 'viewer' && (
                <div onClick={toggleDeleteModal} onKeyDown={() => {}} role="button" tabIndex={0}>
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              )}
            </div>
          </div>
          {status && <MeetingTag code={status} className="meeting-page" />}
          {allowVinCheck && (
            <Button className="ml-3" onClick={createVinCheck} outline color="primary" size="sm">
              {t('vincheck')}
            </Button>
          )}
          {tooltipInfo && (
            <span
              className={`${tooltipInfo?.title ? 'appointment-icon-tag mr-1' : ''} ml-0`}
              data-content={t(tooltipInfo?.title) || ''}
            >
              <FontAwesomeIcon
                icon={tooltipInfo.icon}
                size="1x"
                id="Tooltip-homeHBS"
                className="hbs-icon ml-3"
                onClick={tooltipInfo.onClick}
              />
              <Tooltip
                placement="top"
                isOpen={tooltipInfo.isOpen}
                target="Tooltip-homeHBS"
                toggle={!isMobile && tooltipInfo.onClick}
                className="my-tooltip"
              >
                {t(tooltipInfo.label)}
              </Tooltip>
            </span>
          )}
          {isNrmRecord && ![1, 10].includes(nrmStatusId) && (
            <>
              <span
                href="#"
                role="button"
                id="Tooltip-GuaranteeId"
                onFocus={onClickGuaranteeId}
                className="record-nrm mt-3 text-primary font-weight-bold"
              >
                {guaranteedPrice?.nrmRecordId}
              </span>
              <Tooltip
                placement="top"
                isOpen={isOpenGuaranteeId}
                target="Tooltip-GuaranteeId"
                toggle={!isMobile && onClickGuaranteeId}
                className="my-tooltip"
              >
                {t('guaranteeId')}
              </Tooltip>
            </>
          )}
          {isLoadingVin && (
            <>
              <Spinner color="primary" size="sm" className="ml-3" />
              <span className="ml-1 text-primary">
                <Translate code="vincheck" />
              </span>
            </>
          )}
          <Row>
            <Col xs="6" sm="3" lg="5" className="label">
              {t('meetingDate')}
            </Col>
            <Col xs="6" sm="9" lg="6" className="value text-left">
              {appointmentDate}
            </Col>
          </Row>
          <Row>
            <Col xs="6" sm="3" lg="5" className="label">
              {t('meetingTime')}
            </Col>
            <Col xs="6" sm="9" lg="6" className="value text-left">
              {appointmentTime}
            </Col>
          </Row>
          <Row>
            <Col xs="6" sm="3" lg="5" className="label">
              {t('meetingPointOfSale')}
            </Col>
            <Col xs="6" sm="9" lg="6" className="value text-left">
              {pointOfSaleName}
            </Col>
          </Row>

          {allowedChangeBuyer ? (
            <Row className="justify-content-between align-center">
              <Col xs="6" sm="3" lg="5" className="label">
                {t('buyer')}
              </Col>
              {recordId > 0 && (
                <Col xs="6" sm="9" lg="7" className="value text-left">
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderStyle: 'none',
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                      }),
                      option: (styles, { data, isSelected }) => ({
                        ...styles,
                        backgroundColor: !isSelected ? data?.color : 'rgb(241, 90, 36)',
                        cursor: 'pointer',
                        ':hover': {
                          backgroundColor: isSelected ? data?.color : '#ff731669',
                        },
                      }),
                      valueContainer: (baseStyles) => ({
                        ...baseStyles,
                        paddingLeft: '0px',
                      }),
                      singleValue: (baseStyles) => ({
                        ...baseStyles,
                        color: updateBuyer.error ? '#FF0000' : '#8b8ca3',
                      }),
                    }}
                    value={buyerRecordName}
                    components={{
                      ValueContainer,
                      CustomSingleValue,
                    }}
                    isLoading={updateBuyer.loading}
                    options={buyers.map((buyer) => ({ value: buyer.id, label: t(buyer.fullName) }))}
                    onChange={(e) => chnageBuyerName(e)}
                  />
                </Col>
              )}
            </Row>
          ) : (
            <>
              {buyerFullName && (
                <Row>
                  <Col xs="6" sm="3" lg="5" className="label">
                    {t('buyer')}
                  </Col>
                  <Col xs="6" sm="9" lg="6" className="value text-left">
                    {buyerFullName}
                  </Col>
                </Row>
              )}
            </>
          )}
          {counterInspection.recordId && (
            <Row>
              <Col xs="6" sm="3" lg="5" className="label">
                {(recordTypeId === 2 && t('initialAppraisal')) || t('counterAppraisalLinked')}
              </Col>
              <Col xs="6" sm="9" lg="6" className="text-left">
                <Link to={`/files/${counterInspection.recordId}`} target="_blank">
                  <u>{counterInspection.refHexaId}</u>
                </Link>
              </Col>
            </Row>
          )}
        </>
      )}
      {appointmentDateTime && allowEdit && (
        <EditAppointmentModal
          recordId={recordId}
          concessionId={pointOfSaleId}
          concessionName={pointOfSaleName}
          appointmentDateTime={appointmentDateTime}
          toggle={toggleEditModal}
          isOpen={editModalIsOpen}
          records={records}
          role={role}
          recordTypeId={recordTypeId}
          counterInspection={counterInspection}
          showModelCounterInspaction={showModelCounterInspaction}
        />
      )}
      <DeleteModal recordId={recordId} toggle={toggleDeleteModal} isOpen={deleteModalIsOpen} />
    </div>
  );
};

AppointmentBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
